import { IMakeAwishAPIResponse } from "../types/make-a-wish-types.types";
import { API_PATHS } from "../constants/api-paths";
import { encryptedRequest, request } from "../core/api.client";

export const getMakeAWishArticles = async (dealerId: string) => {
  const response: { data: IMakeAwishAPIResponse } = await encryptedRequest({
    method: "POST",
    url: API_PATHS.qrDealer,
    data: { dealerId },
  });
  return response;
};

export const getMakeAWishArticlesV2 = async (business: string) => {
  const response: { data: IMakeAwishAPIResponse["data"] } = await request({
    method: "POST",
    url: API_PATHS.qrUrbanRuralAPI,
    data: { business },
  });
  return response;
};
